import moment from "moment";
import { Button } from "@mui/material";
import { GrUpdate } from "react-icons/gr";
import { LoadingOutlined } from "@ant-design/icons";
import { Modal, Row, Spin, Typography } from "antd";
import { Fragment, useEffect, useState } from "react";
import { formatCurrency } from "../../utils";
import { LucroPrejuizo, PosicaoCard } from "./PosicaoCard";
import { useCarteira } from "../../contexts/CarteiraContext";
import { Container, Content, Posicoes, Toolbar } from "./styles";

interface CarteiraProps { }

export const Carteira: React.FC<CarteiraProps> = () => {
  const { carteira, lastUpdate, loading, getCarteira } = useCarteira();
  const [helpModal, setHelpModal] = useState<any>();

  const onCloseHelpModal = () => setHelpModal(undefined);

  // const carteiraCategorizada = useMemo(
  //   () =>
  //     carteira?.posicoes?.reduce(
  //       (acc, cur) => ({
  //         ...acc,
  //         [cur.categoria]: [...(acc[cur.categoria] || []), cur],
  //       }),
  //       {} as { [key: string]: Posicao[] }
  //     ) || {},
  //   [carteira?.posicoes
  //   ]
  // );

  useEffect(() => {
    getCarteira && getCarteira();
  }, [getCarteira]);


  return (
    <Container>
      <Typography.Title level={1}>Meus investimentos</Typography.Title>
      <Toolbar>
        <Typography.Title level={2} style={{ margin: 0, alignItems: 'center' }}>
          Última atualização:{" "}
          {moment(lastUpdate).utc().local().format("DD/MM/YYYY à[s] HH:mm")}
          <Button
            onClick={() => getCarteira()}
            startIcon={
              loading ? <LoadingOutlined size={16} /> : <GrUpdate size={16} />
            }
          />
        </Typography.Title>
        {/* <StatusBar /> */}
      </Toolbar>
      <Content>
        <Typography.Title level={2}>Patrimônio atual:</Typography.Title>
        <Typography.Title level={1}>
          {loading ? <Spin /> : formatCurrency(carteira?.patrimonioTotal)}
        </Typography.Title>
        <Typography.Paragraph>
          Lucro/prejuízo diário:{" "}
          {loading ? (
            <Spin />
          ) : (
            <LucroPrejuizo
              n={carteira?.lucroPrejuizoDiario}
              p={carteira?.lucroPrejuizoDiarioPercentual}
            />
          )}
        </Typography.Paragraph>
        <Typography.Paragraph>
          Lucro/prejuízo total:{" "}
          {loading ? (
            <Spin />
          ) : (
            <LucroPrejuizo
              n={carteira?.lucroPrejuizoTotal}
              p={carteira?.lucroPrejuizoTotalPercentual}
            />
          )}
        </Typography.Paragraph>
      </Content>
      <Typography.Title level={1}>Posições</Typography.Title>
      <Content>
        {loading ? (
          <Row justify="center">
            <LoadingOutlined />
          </Row>
        ) : carteira?.posicoes?.length > 0 ? (
          <>
            {(
              <Posicoes expandIconPosition="right">
                {carteira?.posicoes.slice(0, 1).map((posicao, index) => (
                  <Fragment key={index}>
                    {PosicaoCard({
                      key: index.toString(),
                      posicao,
                      setHelpModal,
                    })}
                  </Fragment>
                ))}
              </Posicoes>
            )}
            {/* {(
              <BlurContent>
                <Posicoes
                  collapsible="disabled"
                  className="blur-content"
                  expandIconPosition="right"
                >
                  {Array.from(Array(3).keys()).map((index) => (
                    <Fragment key={index}>
                      {PosicaoCard({
                        key: index.toString(),
                        setHelpModal,
                      })}
                    </Fragment>
                  ))}
                </Posicoes>
              </BlurContent>
            )} */}
          </>
        ) : (
          <Typography style={{ textAlign: "center" }}>
            Nenhuma posição encontrada
          </Typography>
        )}
      </Content>
      <Modal
        footer={null}
        visible={helpModal}
        title={helpModal?.title}
        onCancel={onCloseHelpModal}
      >
        {helpModal?.content}
      </Modal>
    </Container>
  );
};
